import { cosDevelopment, cosProduction, cosTest, type CosConfig } from "./cos";

/** 模板服务 */
export interface TplServiceConfig {
  /** 黑名单分享功能最低准入限制（发货数） */
  blackListMinSendRequired: number;
}

export interface AppConfig {
  appName: string;
  apiRoot: string;
  /** 官网 Origin，供 webview iframe / 外链跳转使用 */
  webOrigin: string;
  qqClientId: string;
  qqRedirectUri: string;
  cos: CosConfig;
  tplService: TplServiceConfig;
}

const tplService: TplServiceConfig = {
  blackListMinSendRequired: 1500,
};

const appByMode: Record<string, AppConfig> = {
  development: {
    appName: "[测试]兽聚汇",
    apiRoot: "http://192.168.88.6:10001",
    webOrigin: "http://192.168.88.6:5173",
    qqClientId: "1904269013",
    qqRedirectUri: "http://localhost:5173/auth/callback/qq",
    cos: cosDevelopment,
    tplService: { ...tplService },
  },
  test: {
    appName: "[测试]兽聚汇",
    apiRoot: "https://api.dev.furries.cn",
    webOrigin: "https://www.furries.cn",
    qqClientId: "1904269013",
    qqRedirectUri: "https://www.furries.cn/auth/callback/qq",
    cos: cosTest,
    tplService: { ...tplService },
  },
  production: {
    appName: "兽聚汇",
    apiRoot: "https://api.furries.cn",
    webOrigin: "https://www.furries.cn",
    qqClientId: "1904269013",
    qqRedirectUri: "https://www.furries.cn/auth/callback/qq",
    cos: cosProduction,
    tplService: { ...tplService },
  },
};

const fallback = appByMode.test;

/** 与 Vite `import.meta.env.MODE` 保持一致 **/
export function getAppConfig(mode: string): AppConfig {
  return appByMode[mode] ?? fallback;
}
